import { handleQueryError, catchQueryErrors } from '../../helpers/ErrorHelper';
import { tryRequest, withTimeout } from '../../helpers/RetryHelper';
import moment from 'moment';

function handleFetchErrors (response) {
  if (!response.ok) { return Promise.reject(response); }
  return response;
}

const TIMEOUT = 15000; // make health check call expire
const fetchWithTimeout = (...args) => withTimeout(fetch(...args), TIMEOUT);
function healthCheckFactory (isNetworkAvailable) {
  return () => tryRequest((retry, { remaining }) => {
    return fetchWithTimeout(`https://${window.sbvrenv.API_URL}/system-health`)
      .then(handleFetchErrors)
      .catch(handleQueryError())
      .catch((e) => {
        if (remaining && isNetworkAvailable) return retry();
        else throw e;
      });
  }, { times: [0, 5000, 10000] });
}

export default {
  state: {
    isNetworkAvailable: true,
    momentLastConnected: null,
  },
  mutations: {
    setNetworkAvaibility (state, isNetworkAvailable) {
      state.isNetworkAvailable = isNetworkAvailable;
    },
    setMomentLastConnectedToNow (state) {
      state.momentLastConnected = moment().format();
    },
  },
  actions: {
    async checkServiceHealth ({ commit, getters }) {
      if (this._healthCheckWaiting) return;
      this._healthCheckWaiting = true; // allow to run only one single health check at a time
      let networkAvaibility = true;
      if (!this._healthCheck) this._healthCheck = healthCheckFactory(getters.isNetworkAvailable);
      try {
        await this._healthCheck();
      } catch (e) {
        catchQueryErrors(e, () => {
          networkAvaibility = false;
          commit('setMomentLastConnectedToNow');
        });
      } finally {
        this._healthCheckWaiting = false;
        this._healthCheck = undefined;
        commit('setNetworkAvaibility', networkAvaibility);
      }
    },
  },
  getters: {
    isNetworkAvailable (state) {
      return state.isNetworkAvailable;
      // This is for testing... comment the line above and uncomment the line below to enable safety mode
      // return false;
    },
    momentLastConnected (state) {
      return state.momentLastConnected;
      // This is for testing... comment the line above and uncomment the line below to enable safety mode
      // return moment().format();
    },
  },
};
